@if (inRange()) {
<span (click)="clickHandler($event)" class="day__wrapper">{{ day }}</span>
} @if (!inRange()) {
<span class="day__range">{{ day }}</span>
}
